// invoice status type for cetustek list & export
export const VALID = 'active';
export const INVALID = 'cancel';
